import DeleteShopArticleTaxByIdRequestModelBase from '../_generated/modelBases/delete-shop-article-tax-by-id-request-model-base';

export default class DeleteShopArticleTaxByIdRequestModel extends DeleteShopArticleTaxByIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
